export type Chapter = {
  label: string
  title: string
  summary: string
  page: string
}

export type Failure = {
  title: string
  body: string
}

export type Testimonial = {
  name: string
  detail: string
  quote: string
  result: string
}

export type Faq = {
  question: string
  answer: string
}

export const product = {
  title: 'Vientre Plano Express',
  duration: '7 Días',
  promise:
    'La guía definitiva para eliminar la hinchazón y recuperar tu confianza en una semana.',
  subPromise: 'Adiós a la pesadez. Hola a tu mejor versión.',
  edition: 'Edición 2024 — Protocolo de Emergencia',
  audience: 'Preparado exclusivamente para la mujer decidida',
  price: '9.99',
  compareAt: '47',
  checkoutUrl: 'https://brujulavivashop.com/cart/43475133235261:1',
  currency: 'USD',
  coverImage:
    'https://cdn.magicpatterns.com/uploads/tJRL4oee7Hu417hQ2qsQBZ/VIENTRE_PLANO_7_DIAS_-2.png',
  authorImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/6f0a045a-2987-42ed-8839-819532b2ab24.jpg',
  protocolImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/9d20cf20-d4d5-41d9-bd47-97e079c6dbc3.jpg',
}

export const failures: Failure[] = [
  {
    title: 'Los laxantes',
    body: 'Solo irritan el colon y causan más inflamación como mecanismo de defensa.',
  },
  {
    title: 'Los abdominales',
    body: 'Fortalecen el músculo, pero si está detrás de una pared de aire y retención, nunca se verá plano.',
  },
  {
    title: 'Las dietas de hambre',
    body: 'Estresan el cuerpo y elevan el cortisol. El cortisol te hace acumular agua justo en la barriga.',
  },
]

export const sosFramework = [
  {
    letter: 'S',
    name: 'Sensibilidad',
    question: '¿Sientes el abdomen duro al tacto?',
    verdict: 'Es aire atrapado (gases).',
  },
  {
    letter: 'O',
    name: 'Osmosis',
    question: '¿Si presionas tu piel queda una marca blanca por unos segundos?',
    verdict: 'Es retención de líquidos.',
  },
  {
    letter: 'S',
    name: 'Solidez',
    question: '¿El volumen es igual por la mañana que por la noche?',
    verdict: 'Suele ser tejido adiposo, oculto por la inflamación.',
  },
]

export const chapters: Chapter[] = [
  {
    label: 'Nota de la Autora',
    title: 'El momento del "Ya no más"',
    summary:
      'La historia detrás del protocolo y por qué años de jugos verdes, fajas y rutinas no cambiaron nada.',
    page: '4',
  },
  {
    label: 'Introducción',
    title: 'El Protocolo de Vacío Intestinal',
    summary:
      'Por qué la inflamación sistémica y el aire atrapado son el problema real, y no la grasa.',
    page: '6',
  },
  {
    label: 'Capítulo 1',
    title: '¿Grasa o Aire? Identificando al Enemigo',
    summary:
      'El marco S.O.S. para diferenciar grasa, gases y retención, más tus disparadores personales.',
    page: '9',
  },
  {
    label: 'Capítulo 2',
    title: 'El Botón de Reinicio (Día 1)',
    summary:
      'El Protocolo de Choque Enzimático: Caldo de Oro y bromelina para la primera reducción visual en 24 horas.',
    page: '14',
  },
  {
    label: 'Capítulo 3',
    title: 'Hidratación Osmótica: la llave del agua',
    summary:
      'Cómo beber para que el cuerpo suelte el líquido retenido en vez de guardarlo.',
    page: '19',
  },
  {
    label: 'Capítulo 4',
    title: 'Masaje de Drenaje Casero de 5 Minutos',
    summary:
      'La secuencia manual paso a paso para mover los desechos estancados y activar el sistema linfático.',
    page: '24',
  },
  {
    label: 'Capítulo 5',
    title: 'El Menú de Emergencia (Días 2 al 7)',
    summary:
      'Seis días de comidas ya resueltas, con listas de compra y alimentos que actúan como imanes del exceso de agua.',
    page: '30',
  },
  {
    label: 'Capítulo 6',
    title: 'El Secreto del Sueño Digestivo',
    summary:
      'Cómo cerrar el día para despertar sin la hinchazón matutina que arruina todo el esfuerzo.',
    page: '36',
  },
]

export const extras: Chapter[] = [
  {
    label: 'Extra',
    title: 'Preguntas Frecuentes',
    summary: 'Las dudas reales que aparecen durante los 7 días, resueltas.',
    page: '41',
  },
  {
    label: 'Extra',
    title: 'Glosario de Términos',
    summary: 'Bromelina, osmosis, drenaje linfático y todo el vocabulario, en simple.',
    page: '45',
  },
  {
    label: 'Extra',
    title: 'Recursos y Herramientas',
    summary: 'Hojas de acción, listas de verificación y el registro de medidas.',
    page: '48',
  },
]

export const testimonials: Testimonial[] = [
  {
    name: 'María G.',
    detail: 'Empezó un jueves, tenía boda el sábado',
    quote:
      'Solo con el Caldo de Oro y eliminar la sal procesada bajé 2 libras de puro líquido en 24 horas. La cara se me desinflamó y el abdomen bajó 2 centímetros antes de siquiera empezar con el menú sólido.',
    result: '−2 cm en el Día 1',
  },
  {
    name: 'Carolina R.',
    detail: '38 años, dos hijos',
    quote:
      'Yo juraba que era grasa. Hice la prueba de presión del Capítulo 1 y entendí en cinco minutos que era retención. Cambió por completo lo que estaba haciendo mal.',
    result: 'El jean cerró sin acostarse',
  },
  {
    name: 'Daniela P.',
    detail: 'Sesión de fotos en 7 días',
    quote:
      'El masaje de drenaje de 5 minutos fue lo que más me sorprendió. Es gratis, lo hago en la cama y la diferencia por la mañana es real.',
    result: 'Sin pesadez al final del día',
  },
]

export const faqs: Faq[] = [
  {
    question: '¿Voy a pasar hambre durante estos 7 días?',
    answer:
      'No. Este no es un plan de ayuno. El Día 1 es una simplificación total basada en caldos claros y piña fresca, y del Día 2 al 7 sigues el Menú de Emergencia con comidas completas. El objetivo es drenaje digestivo, no restricción.',
  },
  {
    question: '¿Necesito comprar suplementos o productos especiales?',
    answer:
      'No. Todo el protocolo se arma con ingredientes de supermercado: agua, apio, jengibre, cebolla, piña fresca y los alimentos del menú. No se vende ni se requiere ningún producto adicional.',
  },
  {
    question: '¿En cuánto tiempo veo el primer cambio?',
    answer:
      'El Día de Reinicio está diseñado para lograr la primera reducción visual en menos de 24 horas. Dicho esto, los resultados varían según la persona y no se garantizan resultados específicos.',
  },
  {
    question: '¿Sirve si mi problema es grasa y no hinchazón?',
    answer:
      'El Capítulo 1 te enseña a distinguirlo con el marco S.O.S. Incluso cuando hay tejido adiposo, la inflamación suele ocultar los resultados; al desinflamar, por fin ves lo que hay debajo.',
  },
  {
    question: '¿Cómo recibo la guía?',
    answer:
      'Es un PDF digital. Llega a tu correo inmediatamente después de la compra y lo lees en el celular, la tablet o la computadora. Es tuyo para siempre, sin suscripciones.',
  },
  {
    question: '¿Puedo hacerlo si tengo una condición médica?',
    answer:
      'Consulta a tu médico antes de empezar. Este material es informativo y educativo, y no sustituye el consejo, diagnóstico o tratamiento médico profesional.',
  },
]

export const includes = [
  'El Protocolo de Vacío Intestinal completo, día por día',
  'El marco S.O.S. para identificar tu tipo de hinchazón',
  'La receta del Caldo de Oro y el Choque Enzimático del Día 1',
  'El Menú de Emergencia de los Días 2 al 7',
  'El masaje de drenaje casero de 5 minutos',
  'Hojas de acción y listas de verificación por capítulo',
]
